import React from 'react'
import { Link } from 'react-router-dom'
import { FaPlus } from 'react-icons/fa'
import '@resources/css/request.css'

interface AddDonorButtonProps {
  currentCount: number
  maxCount?: number
  minCount?: number
  showCounter?: boolean
}

const AddDonorButton: React.FC<AddDonorButtonProps> = ({
  currentCount,
  maxCount = 6,
  minCount = 1,
  showCounter = true,
}) => {
  return (
    <div className="add-donor-wrapper">
      <Link to="/" target="_blank" className="add-donor-card">
        <div className="add-icon">
          <FaPlus size={20} />
        </div>
        <div className="add-donor-content">
          <h6 className="add-title">Adicionar doador</h6>
          <p className="add-subtitle">Máximo de {maxCount} doadores</p>
        </div>
      </Link>

      {showCounter && (
        <div className="donor-counter">
          <span className="counter-text">
            {currentCount} de {maxCount} doadores selecionados
            {currentCount < minCount && currentCount > 0 && (
              <span className="min-required"> (mínimo {minCount})</span>
            )}
          </span>
          <div className="counter-dots">
            {Array.from({ length: maxCount }).map((_, index) => (
              <span
                key={index}
                className={`counter-dot ${
                  index < currentCount
                    ? currentCount < minCount
                      ? 'active warning'
                      : 'active'
                    : ''
                }`}
              />
            ))}
          </div>
        </div>
      )}
    </div>
  )
}

export default AddDonorButton
